export const OpenDialogTriggeredSignal = "OpenDialogTriggeredSignal";
export const CloseDialogTriggeredSignal = "CloseDialogTriggeredSignal";
export const GetSignalRegisters = "GetRegister";
export const GetSignalRegistersSuccess = "GetRegisterSuccess";
export const GetSignalRegistersError = "GetRegisterError";
export const GetRecordersIds = "GetRecordersIds";
export const GetRecordersIdsSuccess = "GetRecorderSuccess";
export const GetRecordersIdsError = "GetRecorderError";

